@if (showSpinner) {
	<div class="c-spinner c-spinner--visible">
		<mat-spinner [diameter]="diameter" data-test-id="spinner"/>
</div>
}

@if (!showSpinner) {
	<ng-content data-test-id="spinner-content"/>
}
